import type ProjectTileItem from '@modules/tile/type/project-tile-item';

const getProjectTileProps = (data: ProjectTileItem) => {
    return {
        projectLink: data.Link,
        imageUrl: data.TileThumbUrl,
        projectName: data.Title,
        professionalID: data.Professional?.ID,
        professional: `By ${data.Professional?.Title}`,
        professionalLink: data.Professional?.Link,
    };
};

export default getProjectTileProps;
